import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { db } from '../utils/firebase';
import '../styles/AdminPanel.css';

const AdminPanel = () => {
  const { authReady, isAdmin } = useAuth();
  const [chefBookings, setChefBookings] = useState([]);
  const [cateringBookings, setCateringBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!authReady || !isAdmin) return;

    const fetchAllBookings = async () => {
      try {
        const chefSnapshot = await getDocs(collection(db, 'chefBookings'));
        const cateringSnapshot = await getDocs(collection(db, 'cateringBookings'));

        setChefBookings(
          chefSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        );
        setCateringBookings(
          cateringSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        );
      } catch (err) {
        console.error('Error fetching bookings:', err);
        setError('Failed to fetch bookings. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchAllBookings();
  }, [authReady, isAdmin]);

  if (!authReady) {
    return <p className="loading">Checking access...</p>;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  const renderTable = (title, bookings) => (
    <section className="booking-section">
      <h3>{title}</h3>
      {bookings.length === 0 ? (
        <p className="no-data">No bookings available.</p>
      ) : (
        <div className="table-wrapper">
          <table className="booking-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Date</th>
                <th>Persons</th>
                <th>Total (₹)</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map(booking => (
                <tr key={booking.id}>
                  <td>{booking.name || '-'}</td>
                  <td>{booking.email || '-'}</td>
                  <td>{booking.phone || '-'}</td>
                  <td>{booking.date || '-'}</td>
                  <td>{booking.persons || '-'}</td>
                  <td>{booking.total ? `₹${booking.total}` : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );

  return (
    <div className="admin-panel">
      <h2>📋 Admin Dashboard</h2>
      {loading ? (
        <p className="loading">Loading bookings...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : (
        <>
          {renderTable('🍽 Catering Bookings', cateringBookings)}
          {renderTable('👨‍🍳 Chef Bookings', chefBookings)}
        </>
      )}
    </div>
  );
};

export default AdminPanel;
